// Chakra Imports
import {
    Box,
    Flex,
    useColorModeValue,
} from "@chakra-ui/react";
import AdminNavbarLinks from "./AdminNavbarLinks";

export default function AdminNavbar(props) {
    const {
        variant,
        children,
        fixed,
        secondary,
        brandText,
        onOpen,
        ...rest
    } = props;

    let navbarPosition = "fixed";
    let navbarShadow = useColorModeValue(
        "0px 7px 23px rgba(0, 0, 0, 0.05)",
        "0px 7px 23px rgba(0, 0, 0, 0.2)"
    );
    let navbarBg = useColorModeValue(
        "linear-gradient(112.83deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.9) 110.84%)",
        "linear-gradient(112.83deg, rgba(26, 32, 44, 0.95) 0%, rgba(26, 32, 44, 0.9) 110.84%)"
    );
    let navbarBorder = useColorModeValue("gray.200", "gray.700");
    let navbarFilter = useColorModeValue(
        "none",
        "none"
    );

    // Here are all the props that may change depending on navbar's type or state.(secondary, variant)
    let mainText = useColorModeValue("gray.700", "gray.200");
    let navbarBackdrop = "blur(21px)";
    let secondaryMargin = "0px";
    let paddingX = "15px";

    if (props.fixed !== true) {
        navbarPosition = "absolute";
        navbarFilter = "none";
        navbarShadow = "none";
        navbarBg = "none";
        navbarBorder = "transparent";
    }

    if (props.secondary) {
        navbarBackdrop = "none";
        navbarPosition = "absolute";
        mainText = "white";
        secondaryMargin = "22px";
        paddingX = "30px";
    }

    return (
        <Flex
        className="navbar"
        position={navbarPosition}
        boxShadow={navbarShadow}
        bg={navbarBg}
        borderColor={navbarBorder}
        filter={navbarFilter}
        backdropFilter={navbarBackdrop}
        borderBottomWidth="1px"
        borderStyle="solid"
        transitionDelay="0s, 0s, 0s, 0s"
        transitionDuration=" 0.25s, 0.25s, 0.25s, 0s"
        transition-property="box-shadow, background-color, filter, border"
        transitionTimingFunction="linear, linear, linear, linear"
        alignItems={{ xl: "center" }}
        display="flex"
        minH="50px"
        justifyContent={{ xl: "center" }}
        mx="auto"
        mt={secondaryMargin}
        pb="8px"
        left={{sm: 0, xl: 260}}
        px={{
            sm: paddingX,
            md: "30px",
        }}
        ps={{
            xl: "12px",
        }}
        pt="8px"
        w={{ sm: "calc(100vw)", xl: "calc(100vw - 260px)" }}
        >
        <Flex
            w="100%"
            flexDirection={{
                sm: "column",
                md: "row",
            }}
            alignItems={{ xl: "center" }}
        >
            <Box ms="auto" w={{ sm: "100%", md: "unset" }}>
                <AdminNavbarLinks
                    onOpen={props.onOpen}
                    logoText={props.logoText}
                    secondary={props.secondary}
                    fixed={props.fixed}
                />
            </Box>
        </Flex>
        </Flex>
    );
}
